import {
  Modal,
  Form,
  Select,
  Radio,
  Button,
  DatePicker,
  Col,
  Row,
  InputNumber,
  message,
  Tooltip,
} from "antd";
import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import styles from "./index.module.css";
import * as com from "Common.js";
import NewModal from "Common/NewModal";
import { useDispatch, useSelector } from "react-redux";
import { NoticeV2Modal } from "LoanSummary/components/NoticeV2";
import { dateSuffixIcon } from "LoanSummary/components/Notice/Step/options";
import { UpdateLoanOverviewData, UpdateProduct, UpdateSelectedLoanField, UpdateLienPosition } from "Store/actions";
import dayjs from "dayjs";
import eventBus from "../../../Bus";
function replacer(key, value) {
  return value === undefined ? null : value;
}
    // 获取disposition update信息
export  const getDispositionUpdateForm = async (loanId) => {
  let token = sessionStorage.getItem("ZeitroA");
  const response = await fetch("/los/getloanoverviewdata", {
    method: "POST",
    body: JSON.stringify({ loanId }),
    headers: {
      Cache: "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  if (response.status !== 200 || !response) {
    return {};
  }
  const result = await response.json();
  if (result.status === "OK") {
      result.data.dateClosed = result?.data?.dateClosed?dayjs(result?.data?.dateClosed):'';
      result.data.preApprovalLetterExpirationDate = result?.data?.preApprovalLetterExpirationDate?dayjs(result?.data?.preApprovalLetterExpirationDate):'';
      result.data.submittedDate = result?.data?.submittedDate?dayjs(result?.data?.submittedDate):'';
      result.data.receivedDate = result?.data?.dateClosed?dayjs(result?.data?.dateClosed):'';
    return result.data;
  }
  return {};
};

// 请求接口保存信息
export  const updateDispositionUpdateForm = async (data, loanId) => {
  let token = sessionStorage.getItem("ZeitroA");
  if (data.dateClosed){
    data.dateClosed = dayjs(data?.dateClosed).format("MM/DD/YYYY");
  }
  if (data.preApprovalLetterExpirationDate){
    data.preApprovalLetterExpirationDate = dayjs(data?.preApprovalLetterExpirationDate).format("MM/DD/YYYY");
  }

  if (data.submittedDate){
    data.submittedDate = dayjs(data?.submittedDate).format("MM/DD/YYYY");
  }
  const params = {
    loanId,
    data,
  };
  const response = await fetch("/los/updateloanoverviewdata", {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Cache: "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  if (response.status !== 200 || !response) {
    return;
  }
  const result = await response.json();
  if (result.status === "OK") {
    message.success("save successfully！");
  }
};

export const UpdateLoanStatus = forwardRef(
  (
    {
      loanAmount,
      rowProps = {},
      colProps = {},
      colProps2 = {},
      isNoForm = true, // true只能通过change/value的形式绑定，false通过form.setFrildsValue绑定值
      isDispatchRedux = false, // true及时更新redux
      onChange,
      userModifiedStatus,
    },
    ref
  ) => {
    const application = useSelector((w) => w.application);
    const dispatch = useDispatch();
    const handleChangeForm = (value, key) => {
      isDispatchRedux && dispatch(UpdateLoanOverviewData(value, key));
      if (onChange) onChange(value, key);
    };

    const handleChangeLoanType = (value) => {
      isDispatchRedux && dispatch(UpdateProduct(value, "mortgageapplied"));
    }

    const handleChangeLienStatus = (value) => {
      let isSecondLien = false;
      if (value === "subordinatelien") {
        isSecondLien = true;
      } else {
        isSecondLien = false;
      }
      isDispatchRedux && dispatch(UpdateLienPosition(isSecondLien, "issecondlien"));
    }


    // 无loanId直接修改redux,可用于点击保存时才修改值的情况
    const changeRedux = (values) => {
      values.dateClosed = values?.dateClosed
        ? dayjs(values?.dateClosed).format("MM/DD/YYYY")
        : "";
      if (values.finalLoanAmount)
        dispatch(
          UpdateLoanOverviewData(values.finalLoanAmount, "finalLoanAmount")
        );
      if (values.totalBrokerCheck)
        dispatch(
          UpdateLoanOverviewData(values.totalBrokerCheck, "totalBrokerCheck")
        );
      if (values.dateClosed)
        dispatch(UpdateLoanOverviewData(values.dateClosed, "dateClosed"));
      if (values.qmType)
        dispatch(UpdateLoanOverviewData(values.qmType, "qmType"));
      if (values.lienStatus)
        dispatch(UpdateLoanOverviewData(values.lienStatus, "lienStatus"));
      if (values.loanType)
        dispatch(UpdateLoanOverviewData(values.loanType, "loanType"));
      if (values.source)
        dispatch(UpdateLoanOverviewData(values.source, "source"));
      if (values.hoepa)
        dispatch(UpdateLoanOverviewData(values.hoepa, "hoepa"));
    };

    useImperativeHandle(ref, () => ({
      updateDispositionUpdateForm,
      getDispositionUpdateForm,
      changeRedux,
    }));
    return (
      <Row gutter={24} {...rowProps}>
        <Col span={12} {...colProps2}>
          <Form.Item
            label="Submission date"
            labelCol={{ span: 24 }}
            className={styles.formItem}
            {...(isNoForm ? {} : { name: "submittedDate" })}
          >
            <DatePicker
              size="large"
              format="MM/DD/YYYY"
              value={
                application?.loanOverview?.submittedDate
                ? (dayjs.isDayjs(application?.loanOverview?.submittedDate) 
                    ? application?.loanOverview?.submittedDate 
                    : dayjs(application?.loanOverview?.submittedDate, "MM/DD/YYYY"))
                : null
              }
              onChange={(e) =>
                handleChangeForm(
                  e ? dayjs(e).format("MM/DD/YYYY") : null,
                  "submittedDate"
                )
              }
              suffixIcon={dateSuffixIcon}
            />
          </Form.Item>
        </Col>
        <Col span={12} {...colProps2}>
          <Form.Item
            label="Disposition date"
            labelCol={{ span: 24 }}
            className={styles.formItem}
            {...(isNoForm ? {} : { name: "dateClosed" })}
          >
            <DatePicker
              size="large"
              format="MM/DD/YYYY"
              value={
                application?.loanOverview?.dateClosed
                  ? dayjs(application?.loanOverview?.dateClosed, "MM/DD/YYYY")
                  : null
              }
              onChange={(e) =>
                handleChangeForm(
                  e ? dayjs(e).format("MM/DD/YYYY") : null,
                  "dateClosed"
                )
              }
              suffixIcon={dateSuffixIcon}
            />
          </Form.Item>
        </Col>
        <Col span={12} {...colProps}>
          <Form.Item
            label="QM Type"
            labelCol={{ span: 24 }}
            className={styles.formItem}
            {...(isNoForm ? {} : { name: "qmType" })}
          >
            <Select
              options={[
                { label: "QM", value: "qm" },
                { label: "Non-QM", value: "non_qm" },
                { label: "Not subject toQM", value: "notqm" },
              ]}
              size="large"
              value={application?.loanOverview?.qmType}
              onChange={(e) => handleChangeForm(e, "qmType")}
            />
          </Form.Item>
        </Col>
        <Col span={12} {...colProps}>
          <Form.Item
            label={
              <div className="d-flex align-items-center">
                Lien status
                <Tooltip title="Change will be applied to 1003">
                  <img className="ml-2" src="/images/info-tooltip-icon.svg" alt="info-tooltip" />
                </Tooltip>
              </div>
            }
            labelCol={{ span: 24 }}
            className={styles.formItem}
            {...(isNoForm ? {} : { name: "lienStatus" })}
          >
            <Select
              options={[
                { label: "First lien", value: "firstlien" },
                { label: "Subordinate lien", value: "subordinatelien" },
                { label: "No lien", value: "nolien" },
              ]}
              size="large"
              value={application?.loanOverview?.lienStatus}
              onChange={
                (e) => {
                  handleChangeForm(e, "lienStatus")
                  handleChangeLienStatus(e)
                }
              }
            />
          </Form.Item>
        </Col>
        <Col span={12} {...colProps}>
          <Form.Item
            label={
              <div className="d-flex align-items-center">
                Lien status
                <Tooltip title="Change will be applied to 1003">
                  <img className="ml-2" src="/images/info-tooltip-icon.svg" alt="info-tooltip" />
                </Tooltip>
              </div>
            }
            labelCol={{ span: 24 }}
            className={styles.formItem}
            {...(isNoForm ? {} : { name: "loanType" })}
          >
            <Select
              options={[
                { label: "Conventional", value: "conventional" },
                { label: "FHA", value: "fha" },
                { label: "VA", value: "va" },
                { label: "USDA", value: "usda" },
                { label: "Other", value: "other" },
              ]}
              size="large"
              value={application?.loanOverview?.loanType}
              onChange={
                (e) => {
                  handleChangeForm(e, "loanType")
                  handleChangeLoanType(e)
                }
              }
            />
          </Form.Item>
        </Col>
        <Col span={12} {...colProps}>
          <Form.Item
            label="Source"
            labelCol={{ span: 24 }}
            className={styles.formItem}
            {...(isNoForm ? {} : { name: "source" })}
          >
            <Select
              options={[
                { label: "Brokered", value: "brokered" },
                { label: "Retail", value: "retail" },
              ]}
              size="large"
              value={application?.loanOverview?.source}
              onChange={(e) => handleChangeForm(e, "source")}
            />
          </Form.Item>
        </Col>
        <Col span={12} {...colProps}>
          <Form.Item
            label="HOEPA"
            labelCol={{ span: 24 }}
            className={styles.formItem}
            {...(isNoForm ? {} : { name: "hoepa" })}
          >
            <Select
              options={[
                { label: "Yes", value: true },
                { label: "No", value: false },
              ]}
              size="large"
              value={application?.loanOverview?.hoepa}
              onChange={(e) => handleChangeForm(e, "hoepa")}
            />
          </Form.Item>
        </Col>
        <Col span={12} {...colProps}>
          <Form.Item
            label="Loan amount"
            labelCol={{ span: 24 }}
            className={styles.formItem}
          >
            <div className={styles.loanAmount}>$ {com.commaize(loanAmount ?? application?.selection?.loansize)}</div>
            {/* <InputNumber
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) =>
                  value === null || value === void 0
                    ? void 0
                    : value.replace(/\$\s?|(,*)/g, "")
                }
                size="large"
                style={{ width: "100%" }}
                value={application?.selection?.loansize}
                onChange={(e) => handleChangeLoanSize(e, "loansize")}
                controls={false}
                
            /> */}
          </Form.Item>
        </Col>
        { userModifiedStatus==='LoanFunded' && 
          <Col span={12} {...colProps2}>
            <Form.Item
              label="Final loan amount (if different)"
              labelCol={{ span: 24 }}
              className={styles.formItem}
              {...(isNoForm ? {} : { name: "finalLoanAmount" })}
            >
              <InputNumber
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) =>
                  value === null || value === void 0
                    ? void 0
                    : value.replace(/\$\s?|(,*)/g, "")
                }
                size="large"
                style={{ width: "100%" }}
                value={application?.loanOverview?.finalLoanAmount}
                onChange={(e) => handleChangeForm(e, "finalLoanAmount")}
                controls={false}
                
              />
            </Form.Item>
          </Col>
        }
        { userModifiedStatus==='LoanFunded' && 
          <Col span={12} {...colProps}>
            <Form.Item
              label="Total broker check"
              labelCol={{ span: 24 }}
              className={styles.formItem}
              {...(isNoForm ? {} : { name: "totalBrokerCheck" })}
            >
              <InputNumber
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) =>
                  value === null || value === void 0
                    ? void 0
                    : value.replace(/\$\s?|(,*)/g, "")
                }
                size="large"
                style={{ width: "100%" }}
                value={application?.loanOverview?.totalBrokerCheck}
                onChange={(e) => handleChangeForm(e, "totalBrokerCheck")}
                controls={false}
              />
            </Form.Item>
          </Col>
        }
      </Row>
    );
  }
);

const UpdateLoanModal = ({
  loanAmount,
  loanId,
  rowData,
  onCancel,
  isUpdateLoan = true,
  isHaveNotice = true,
  successFn = () => {},
  isChangeRedux = true,
  detailsFn = () => {},
  open = true,
  userModifiedStatus,
  ...props
}) => {
  const [form] = Form.useForm();
  const loanRef = useRef();

  const onFinish = async () => {
    if (isUpdateLoan) {
      // Save
      const values = await form.validateFields();
      if (loanId && !isChangeRedux) {
        await loanRef.current.updateDispositionUpdateForm(values, loanId);
        successFn();
      } else loanRef.current.changeRedux(values);
      onCancel();
      return;
    }
    // Yes
    if (isHaveNotice) {
      eventBus.emit(
        "appendPortalComponent",
        <NoticeV2Modal
          setOpen={(v) => {
            if (!v) {
              eventBus.emit("removePortalComponent");
            }
          }}
          loanId={loanId}
        />
      );
    }
    onCancel();
  };
  const handleClose = (type) => {
    if (isUpdateLoan && type === "Cancel") {
      // Loan Summary
      detailsFn();
      onCancel();
      return;
    }
    // later
    onCancel();
  };

  const getRowData = async () => {
    if (!loanRef.current || !loanId) return;
    const data = await loanRef.current.getDispositionUpdateForm(loanId);
    form.setFieldsValue(data);
  };

  useEffect(() => {
    if (
      open &&
      isUpdateLoan &&
      loanId &&
      JSON.stringify(rowData || {}, replacer) === "{}"
    ) {
      getRowData();
    }
  }, [isUpdateLoan, rowData, loanId, open]);
  return (
    <>
      <NewModal
        title={
          isUpdateLoan ? "Loan Close and Funded" : "Notice of Action Taken"
        }
        open={open}
        width={568}
        onCancel={handleClose}
        onOk={onFinish}
        className={styles.updateModal}
        cancelText={isUpdateLoan ? "Loan Summary" : "Later"}
        okText={isUpdateLoan ? "Save" : "Yes"}
        {...props}
      >
        {isUpdateLoan ? (
          <Form
            name="updateForm"
            form={form}
            initialValues={{
              ...rowData,
              dateClosed: rowData?.dateClosed
                ? dayjs(rowData?.dateClosed, "MM/DD/YYYY")
                : "",
              submittedDate: rowData?.submittedDate
                ? dayjs(rowData?.submittedDate, "MM/DD/YYYY")
                : "",
            }}
            className={styles.updateForm}
          >
            <UpdateLoanStatus
              loanAmount={loanAmount}
              isNoForm={false}
              isDispatchRedux={false}
              ref={loanRef}
              userModifiedStatus={userModifiedStatus}
            />
          </Form>
        ) : (
          <div className={styles.noUpdateLoan}>
            Application successfully disposed. Would you like to initiate a
            Notice of Action Taken now?
          </div>
        )}
      </NewModal>
    </>
  );
};

export default UpdateLoanModal;
